//
import axios from 'axios';

import {
  GET_ODD_HISTORY_REQUEST,
  GET_ODD_HISTORY_SUCCESS,
  GET_ODD_HISTORY_FAILURE
} from 'Store/constants';

import errorMessage from 'Store/actions/errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

const getOddHistoryParams = odds => {
  const eventId = odds.find(odd => odd.ei)?.ei;
  let qParams = 'eventId=' + eventId;
  odds.forEach(odd => qParams += `&marketOutcome=${odd['mrId']}_${odd['ocn']}`);
  return qParams;
};
//kaldırılacak
export const getOddHistory = odds => async dispatch => {

  try {
    if (!odds?.length) return;

    const queryParams = getOddHistoryParams(odds);
    dispatch({
      type: GET_ODD_HISTORY_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/odd-change/history?` + queryParams);

    dispatch({
      type: GET_ODD_HISTORY_SUCCESS,
      payload: res?.data?.content
    });

  } catch (e) {

    dispatch({
      type: GET_ODD_HISTORY_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getOddHistoryv2 = odds => async dispatch => {

  try {
    if (!odds?.length) return;

    const queryParams = getOddHistoryParams(odds);

    dispatch({
      type: GET_ODD_HISTORY_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/v2/odd-change/history?` + queryParams);

    dispatch({
      type: GET_ODD_HISTORY_SUCCESS,
      payload: res?.data?.content
    });

    return res?.data?.content;

  } catch (e) {
    dispatch({
      type: GET_ODD_HISTORY_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
